import React from 'react';
import styled from 'styled-components';
// ANTD
import TextAreaInput from 'components/inputs/TextAreaInput';
import DateInput from 'components/inputs/DateInput';
import Icon from 'components/common/Icon';
import Select from 'antd/lib/select';
import Tooltip from 'antd/lib/tooltip';
// COMPONENTS
import SalesTaxInput from 'components/inputs/SalesTaxInput';
import MoneyInput from 'components/inputs/MoneyInput';
import NumberInput from 'components/inputs/NumberInput';
import CurrencyHelpers from 'lib/helpers/CurrencyHelpers';

const Section = styled.section``;
const Option = Select.Option;

class OtherSection extends React.PureComponent {
  render() {
    const { currencySymbol, invoice } = this.props;
    return (
      <React.Fragment>
        <Section>
          <p>
            Set a
            <span>
              <Select
                size="large"
                style={{
                  display: 'inline-block',
                  fontSize: 16,
                  width: 170,
                  maxWidth: '100%',
                  padding: 4,
                }}
                onChange={discountType => this.props.onChange({ discountType })}
                value={invoice.discountType}
              >
                <Option style={{ fontSize: 16 }} value="percentage">
                  percentage
                </Option>
                <Option style={{ fontSize: 16 }} value="dollar-amount">
                  dollar amount
                </Option>
              </Select>
            </span>
            discount of
            <span>
              {/* Here we are checking invoiceFlow.discountType and if it's a percentage, we show the percentage input. If it's a dollar value, we shoudl the currency input */}
              {invoice.discountType === 'dollar-amount' ? (
                <span
                  className="ant-input-group-wrapper ant-input-group-wrapper-lg"
                  style={{ marginLeft: 8, width: 100 }}
                >
                  <MoneyInput
                    className="ant-input ant-input-lg"
                    style={{ width: 100, fontSize: 17, fontWeight: 500 }}
                    placeholder={this.props.placeholder || 'amount'}
                    currencySymbol={currencySymbol}
                    value={invoice.discountValue}
                    onChange={discountValue => this.props.onChange({ discountValue })}
                  />
                </span>
              ) : (
                <span
                  className="ant-input-group-wrapper ant-input-group-wrapper-lg"
                  style={{ marginLeft: 8, width: 100 }}
                >
                  <NumberInput
                    value={invoice.discountValue}
                    onChange={discountValue => this.props.onChange({ discountValue })}
                  />
                </span>
              )}
            </span>
          </p>
        </Section>
        <Section>
          <p>
            Total sales tax will be
            <span style={{ padding: 4, position: 'relative' }}>
              <SalesTaxInput
                value={invoice.salesTax && invoice.salesTax}
                onChange={salesTax => {
                  console.log(`salesTax ${salesTax}`);
                  this.props.onChange({ salesTax: salesTax });
                }}
              />
              <Tooltip title={`You can edit sales tax from your My Studio area.`}>
                <Icon
                  type="question-circle-o"
                  style={{
                    color: '#999',
                    position: 'absolute',
                    top: 2,
                    right: -20,
                  }}
                />
              </Tooltip>
            </span>
          </p>
        </Section>
        <Section>
          <p>
            The final payment of
            <span className="money-green">
              {' '}
              {CurrencyHelpers.centsToDollars(invoice.finalPaymentAmount, {
                symbol: currencySymbol,
              })}{' '}
            </span>
            is due on
            <span style={{ padding: 4 }}>
              <DateInput
                onChange={value =>
                  this.props.onChange({
                    finalPaymentDueDate: value,
                  })
                }
                value={invoice.finalPaymentDueDate}
              />
            </span>
            .
          </p>
        </Section>
        <Section>
          <div style={{ width: 500, maxWidth: '100%' }}>
            <p>Memo:</p>
            <TextAreaInput
              onChange={e =>
                this.props.onChange({
                  memo: e.target.value,
                })
              }
              value={invoice.memo}
              size="large"
            />
          </div>
        </Section>
      </React.Fragment>
    );
  }
}

export default OtherSection;



// WEBPACK FOOTER //
// ./src/routes/invoice-create/CreateStep/OtherSection/index.js